import { render, staticRenderFns } from "./AppDescriptionCalendarioOlimpico.vue?vue&type=template&id=5023e20f&"
import script from "./AppDescriptionCalendarioOlimpico.vue?vue&type=script&lang=js&"
export * from "./AppDescriptionCalendarioOlimpico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports